
class BPFS {
    constructor() {        
        var _this = this;
        window.wlm_bpfs_class_selector = '';
        if (window.wlm_local_data == undefined) {
            window.wlm_local_data = {}
        }

        window.wlm_bpfs_mode = "filter";
        window.wlm_bpfs_plan = 'free'

        if (window.boostPFS) {
            window.wlm_bpfs_plan = "free";
            console.log('free');
            _this.hideShowLoader(true);
            
        } else if (window.bcsffilter) {            
            console.log('paid');
            window.wlm_bpfs_plan = "paid";
            _this.hideShowLoader(true);
        }

        _this.WLMDOMContentLoaded();
        _this.observeHead(); // This now contains the DOM observer
        _this.observeSearch();

    }

    WLMDOMContentLoaded() {
        var _this = this;
        let checkDomStatus = setInterval(() => {
            if (document.readyState === 'complete') {
                clearInterval(checkDomStatus);
                _this.hideShowLoader(false);

                if (window.boostPFS) {
                    console.log('Free');
                    window.wlm_bpfs_plan = "free";
                } else if (window.bcsffilter) {
                    console.log('paid');
                    window.wlm_bpfs_plan = "paid";
                }
            }
        }, 100);
    }

    customFind(arr, callback) {
        for (var i = 0; i < arr.length; i++) {
            var match = callback(arr[i]);
            if (match) {
                return arr[i];
            }
        }
    }

    saveWLMHideProductLocally(json) {
        if (!window.wlm_local_data.hideProductPayload) {
            window.wlm_local_data.hideProductPayload = json;
        } else if (json.products.length) {
            window.wlm_local_data.hideProductPayload.products = [].concat(
                window.wlm_local_data.hideProductPayload.products,
                json.products
            );
        }
    }

    hideShowLoader(loader) {
      if(document.getElementById('wlm-loader-container') == null){return;}
        try {
            if (loader) {
                document.getElementById('wlm-loader-container').style.display = "block";
            } else {
                document.getElementById('wlm-loader-container').style.display = "none";
            }
        } catch (e) {
            console.log(e);
        }
    }

    getProductContainer(wlm_bpfs_mode = "filter") {
        if (wlm_bpfs_mode === "search") {
            if (window.wlm_bpfs_plan === "free") {
                return document.querySelectorAll(".boost-sd__product-item");
            }
            if ((window.wlm_bpfs_plan === "paid")) {
                return document.querySelectorAll(".bc-sf-search-suggestion-item-product");
            }
        } else if (wlm_bpfs_mode === "filter") {
            if (window.wlm_bpfs_plan === "free") {
                try {
                    return document.querySelector(".boost-sd__product-list");
                } catch (e) {}
            }
            if (window.wlm_bpfs_plan === "paid" && window.bcsffilter != undefined) {
                const selector = window.bcsffilter.selector.products;
                return document.querySelector(selector);
            }
        }
    }

    getFilterProductSelector() {
        return ":scope > div";
    }

    getHandleFromProductUrl(url = null) {
        if (url === null) {
            url = this.currentUrl();
        }
        const tempEl = document.createElement("a");
        tempEl.href = url;
        const matches = tempEl.pathname.match("/products/(.*)");
        return matches && matches.length > 1 && matches[1];
    }

    getProductList() {
        var _this = this;
        const productList = [];
        const productContainer = _this.getProductContainer("filter");
        if (!productContainer) return productList;

        const productSel = _this.getFilterProductSelector();
        const products = productContainer.querySelectorAll(productSel);

        for (let product of products) {
            const productNameAnchorEl = product.querySelector("a");
            if (!productNameAnchorEl) continue;
            const handle = _this.getHandleFromProductUrl(productNameAnchorEl.href);
            productList.push(handle);
        }
        return productList;
    }

    getProductListFromSearch() {
        var _this = this;
        const productList = [];
        const products = _this.getProductContainer("search");
        for (let productNode of products) {
            const productNameAnchorEl = productNode.querySelector("a");
            if(!productNameAnchorEl) continue;
            const handle = _this.getHandleFromProductUrl(productNameAnchorEl.href);
            productList.push(handle);
        }
        return productList;
    }

    getBoostPFSProductsContainer() {
        if (window.wlm_bpfs_mode === "search") {
            if (window.wlm_bpfs_plan === "free") {
                return document.querySelectorAll(".boost-sd__product-item");
            }
            if ((window.wlm_bpfs_plan === "paid")) {
                return document.getElementsByClassName('bc-sf-search-suggestion-item-product');
            }
        } else if (window.wlm_bpfs_mode === "filter") {
            if (window.wlm_bpfs_plan === "free") {
                return document.querySelectorAll(".boost-sd__product-item");
            }
            if (window.wlm_bpfs_plan === "paid" && window.bcsffilter != undefined ) {
                let container = document.querySelector(window.bcsffilter.selector.products);
                return container ? container.children : [];
            }
        }
        return [];
    }

    RemoveHideProducts() {
        var _this = this;            
        let BoostPFSProductsContainer = _this.getBoostPFSProductsContainer();
        let products = (window.wlm_bpfs_mode == "filter") ? _this.getProductList() : _this.getProductListFromSearch();
        
        products.forEach(function (product) {
            var isHide = _this.customFind(window.wlm_local_data.hideProductPayload.products, function (LocalProduct) {
                return product == LocalProduct.handle;
            });
            if (isHide == undefined) {
                for (var i = 0; i < BoostPFSProductsContainer.length; i++) {
                    let isRemoveContainer = false;
                    let aTagContainers = BoostPFSProductsContainer[i].querySelectorAll('a');
                    for (var j = 0; j < aTagContainers.length; j++) {
                        let parts = aTagContainers[j].href.split('/');
                        let handle = parts[parts.length - 1].split('?')[0];
                        if (product == handle) isRemoveContainer = true;
                    }
                    if (isRemoveContainer) BoostPFSProductsContainer[i].remove();
                }
            }
        });
        _this.hideShowLoader(false);
    }

    checkIsProductHide(handles = []) {
        var _this = this;
        _this.hideShowLoader(true);
        if (!handles || !handles.length) {
            _this.hideShowLoader(false);
            return;
        }
        const filteredHandles = handles.filter((handle) => {
            if (!window.wlm_local_data.hideProductPayload) return true;
            if (!handle) return false;
            let checkHandle = _this.customFind(window.wlm_local_data.hideProductPayload.products, function (p) {
                return p.handle == handle;
            });
            return checkHandle == undefined;
        });

        if (filteredHandles.length === 0) {
            _this.RemoveHideProducts();
            return;
        }

        const maxHandleLimit = 20;
        for (let i = 0; i < filteredHandles.length; i += maxHandleLimit) {
            let paged = filteredHandles.slice(i, i + maxHandleLimit);
            const url = `/search?view=wlm-api&handle=${paged.join(",")}`;
            var xhttp = new XMLHttpRequest();
            xhttp.open("GET", url, false); // Synchronous as per your original code
            xhttp.send();
            if (xhttp.status == 200) {
                var json = JSON.parse(xhttp.responseText);
                _this.saveWLMHideProductLocally(json);
            }
        }
        _this.RemoveHideProducts();
    }

    isSearchPage() {
        return window.location.toString().match(/\/search\?/);
    }

    currentUrl() {
        return window.location.toString();
    }

    observeSearch() {
        var _this = this;
        let SerchObserverTimeout = setInterval(function () {
            let SearchContainer = null;
            if (window.wlm_bpfs_plan === "free" && window.boostPFS && window.boostPFS.search) {                
                SearchContainer = window.boostPFS.search.children;
            }
            if (window.wlm_bpfs_plan === "paid" && window.bcsffilter && window.bcsffilter.class) {
                SearchContainer = document.querySelector("." + window.bcsffilter.class.searchSuggestionWrapper);
            }

            if (SearchContainer != null) {
                clearInterval(SerchObserverTimeout);
                const observerSearch = new MutationObserver(() => {
                    window.wlm_bpfs_mode = "search";
                    _this.checkIsProductHide(_this.getProductListFromSearch());
                });

                if (window.wlm_bpfs_plan === "free") {
                    for (var j = 0; j < SearchContainer.length; j++) {
                        observerSearch.observe(SearchContainer[j].searchAutoComplete.$element[0], { subtree: true, childList: true });
                    }
                } else {
                    observerSearch.observe(SearchContainer, { subtree: true, childList: true });
                }
            }
        }, 100);
    }

    observeHead() {
        var _this = this;
        
        // 1. Target the main content area (or body) to watch for the Product List appearing
        const targetNode = document.body; 
        
        const config = { childList: true, subtree: true };

        const callback = (mutationsList) => {
            // Check if product list exists in DOM
            const productList = document.querySelector(".boost-sd__product-list") || 
                                (window.bcsffilter && document.querySelector(window.bcsffilter.selector.products));

            if (productList) {
                // If products are inside (at least one item), run the logic
                if (productList.children.length > 0) {
                    window.wlm_bpfs_mode = "filter";
                    let products = _this.getProductList();
                    _this.checkIsProductHide(products);
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
}
var wlm_BPFSinit = new BPFS();